import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=f2dcaa2a&scoped=true"
import script from "./Builder.vue?vue&type=script&lang=ts"
export * from "./Builder.vue?vue&type=script&lang=ts"
import style0 from "./Builder.vue?vue&type=style&index=0&id=f2dcaa2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dcaa2a",
  null
  
)

export default component.exports